import gql from 'graphql-tag'

export const LatestOrdersGQL = gql`
  query latestOrders($params: OrdersFilter!) {
    merchant {
      orders(params: $params) {
        content {
          amount
          awardAggregator
          awardAmount
          canChangeStatus
          check {
            amount
            checkDate
            currency
            deviceUid
            fn
            number
            sourceQr
          }
          orderedAt
          currency
          currencyPartnerCommission
          source
          status
          user {
            firstName
            lastName
            patronymic
            approvedOrders
            declinedOrders
            externalUserId
            email
          }
        }
        currentPage
        totalElements
        totalPages
      }
    }
  }
`
